/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { FeatureCardFragment } from "@cosmos/hygraph-schema";

import { CosmosTagProps, TagList, CollapsibleCardViewport } from "@components/elements";
import { css, cx } from "@panda/css";
import { grid, stack } from "@panda/patterns";

import { FeatureCard } from "./FeatureCard.molecule";

export type FeatureCardsProps = {
	cards?: FeatureCardFragment[] | null;
	tags?: CosmosTagProps[] | null;
	tagListTitle?: string | null;
};

export function FeatureCards({ cards = [], tags, tagListTitle }: FeatureCardsProps): React.JSX.Element | null {
	if (!cards || !cards.length) return null;

	return (
		<div
			className={cx(
				"feature-section",
				css({ w: "full", h: "full" }),
				stack({ direction: "column", gap: "eds.dimension.48" }),
			)}
		>
			<CollapsibleCardViewport
				viewportCss={grid.raw({
					columnGap: "eds.dimension.16",
					rowGap: "eds.dimension.16",
					columns: { base: 4, xlDown: 3, lgDown: 2, smDown: 1 },
				})}
			>
				{(cards || []).map((card, i) => (
					<FeatureCard
						key={`feature-card-${i}`}
						{...card}
						analytics={{
							eventCategory: "tile",
							eventLabel: card.label || "",
							eventValue: {
								component: "FeatureCards",
								index: i,
							},
						}}
					></FeatureCard>
				))}
			</CollapsibleCardViewport>
			<TagList title={tagListTitle || ""} tags={tags || []}></TagList>
		</div>
	);
}
